export default function TermsOfService() {
  return (
    <div className="mx-auto max-w-screen-md px-6 py-16 md:py-24" data-testid="terms-page">
      <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-accent">
        <span className="h-px w-10 bg-accent" /> Legal
      </p>
      <h1 className="mt-6 font-serif text-4xl font-bold tracking-tight md:text-5xl">Terms of Service</h1>
      <p className="mt-3 text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</p>

      <div className="prose-sm mt-10 space-y-8 text-sm leading-relaxed text-foreground/85 md:text-base">
        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">Not an emergency service</h2>
          <p className="mt-3">
            Eunoia is not equipped to handle medical or psychiatric emergencies. If you are in crisis or
            thinking of self-harm, please contact KIRAN (1800-599-0019, 24×7, free) or the national Tele
            MANAS helpline (1-800-891-4416), or go to your nearest emergency room.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">Booking and payments</h2>
          <p className="mt-3">
            Sessions are scheduled and paid for through our booking partner, Cal.id. By booking a
            session, you also agree to Cal.id's own terms for scheduling and payment processing. Eunoia
            is not a party to that payment transaction.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">Rescheduling and cancellations</h2>
          <p className="mt-3">
            You can reschedule a session by contacting us — see our Contact page. Specific cancellation
            windows and refund terms are as shown at the time of booking.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">Therapist relationship</h2>
          <p className="mt-3">
            Eunoia connects you with independent, qualified psychologists. The therapeutic relationship
            and any advice given is between you and your therapist. Eunoia does not provide medical or
            psychiatric diagnoses itself.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">Changes to these terms</h2>
          <p className="mt-3">
            We may update these terms from time to time. Continued use of Eunoia after changes means you
            accept the updated terms.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-bold text-foreground">Contact</h2>
          <p className="mt-3">
            Questions about these terms? Write to us at{" "}
            <a href="mailto:admin@eunoia.care" className="font-semibold text-accent underline-offset-4 hover:underline">
              admin@eunoia.care
            </a>
            .
          </p>
        </section>
      </div>
    </div>
  );
}
